import {useState} from "react";
import {useMe} from "../../../hooks/useGetUser";
import SendIcon from "../../../images/icons/sendIcon";
import AddIcon from "../../../images/icons/addIcon";
import {useUpdateTechnician} from "../../../hooks/useUpdateUser";
import TrashIcon from "../../../images/icons/trashIcon";
import Loader from "../shared/Loader";
import FranceMap from "../Map/FranceMap";

const ProfileZones = ({isActive, anonymeData}) => {
  const {data, isLoading} = useMe();
  if (isLoading) {
    return <Loader className={"!relative"} />;
  }

  if (!isActive) {
    return null;
  }

  const interventionAreas = !!anonymeData
    ? anonymeData?.InterventionAreas
    : data?.Technician?.InterventionAreas;

  return (
    <div className=" w-full flex justify-start items-start  flex-col md:flex-row gap-4">
      <div className="w-full md:w-1/2 p-6 md:px-1 md:py-11 flex flex-col gap-5 justify-start items-start">
        <div className="text-left font-bold text-xl text-[#19295C]  ">
          Zones d'intervention
        </div>

        <div className="flex gap-3 flex-wrap flex-grow justify-start items-center mt-2">
          {!!interventionAreas.length ? (
            interventionAreas.map((ele) => (
              <div className=" bg-gradient-to-r from-[#0022AA1A] to-[#1A64B91A] gap-2  font-bold text-sm  rounded-3xl px-4 py-2 flex justify-center items-center text-[#1A64B9] ">
                {ele.code}{" "}
              </div>
            ))
          ) : (
            <div className="text-base text-[#7e7e7e]">
              Pas de zones d'intervention indiquées
            </div>
          )}
        </div>
      </div>
      <div className="w-full  md:block md:w-1/2 p-6 md:px-6 md:py-11 relative ">
        <FranceMap
          highlightedPostCodes={interventionAreas.map((ele) => ele.code)}
        />
      </div>
    </div>
  );
};

export default ProfileZones;
